import constants from "domuso-constants";
import { ApiError } from "./error";

export const ERROR_CODES = {
  GENERIC: 0,
  // straight from vantiv
  CREDIT_CARD_AVS_ACCOUNT_NUMBER: 301,
  CREDIT_CARD_AVS_ACCOUNT_NUMBER_MISMATCH: 302,
  CREDIT_CARD_AVS_STOLEN: 304,
  CREDIT_CARD_AVS_EXPIRED: 305,
  CREDIT_CARD_AVS_FAIL: 319,
  CREDIT_CARD_DO_NOT_HONOR: 349,
  // straight from vantiv
  CREDIT_CARD_INSUFFICIENT_FUNDS: 110,
  // straight from vantiv
  CREDIT_CARD_INVALID_AMOUNT: 340,
  INTERNAL_SERVER_ERROR: 5000,
  SCHEMA_VALIDATION_ERROR: 4000,
  THREAT_METRIX_AUTO_DECLINE_FAIL: 5050,
  CREDIT_CARD_INVALID_CVV_ERROR: 5051,
  CREDIT_CARD_INVALID_BILLING_ADDRESS_ERROR: 5052,
  CREDIT_CARD_INVALID_BILLING_ZIP_ERROR: 5053,
  CREDIT_CARD_INVALID_ACCOUNT_NUMBER_ERROR: 5054,
  EXPERIAN_LINK_NO_NAME_MATCH: 6001,

  // Custom Domuso error codes.
  CUSTOM_AVS_FAILED_LOW_ERROR: 10000,
  CUSTOM_AVS_FAILED_MED_ERROR: 10001,
  CUSTOM_AVS_FAILED_HIGH_ERROR: 10002,
  CUSTOM_THREAT_METRIX_ERROR: 10003,
  CUSTOM_GENERAL_PAYMENT_ERROR: 10004,
  // https://domuso.atlassian.net/browse/ENG-1068
  CUSTOM_FREQUENT_PAYMENT_ERROR: 10005,
  DCASH_RETURNS: "DCRF02",
  EXPERIAN_LINK_REQUEST_FAIL: constants.codes.ExperianLinkErrorCodes
    .EXPERIAN_LINK_REQUEST_FAIL as number,
  EXPERIAN_LINK_NO_NAME_MATCH: constants.codes.ExperianLinkErrorCodes
    .EXPERIAN_LINK_NO_NAME_MATCH as number,
};

export const errorMessageIds = {
  [ERROR_CODES.GENERIC]: "errors.generic",
  [ERROR_CODES.INTERNAL_SERVER_ERROR]: "errors.internalServerError",
  [ERROR_CODES.SCHEMA_VALIDATION_ERROR]: "errors.schemaValidationError",
  [ERROR_CODES.THREAT_METRIX_AUTO_DECLINE_FAIL]: "errors.threatMetrixAutoDeclineFail",
  [ERROR_CODES.CREDIT_CARD_DO_NOT_HONOR]: "errors.creditCardDoNotHonor",
  [ERROR_CODES.CREDIT_CARD_AVS_ACCOUNT_NUMBER]: "errors.customGeneralPayment",
  [ERROR_CODES.CREDIT_CARD_AVS_ACCOUNT_NUMBER_MISMATCH]: "errors.customGeneralPayment",
  [ERROR_CODES.CREDIT_CARD_AVS_STOLEN]: "errors.customGeneralPayment",
  [ERROR_CODES.CREDIT_CARD_AVS_EXPIRED]: "errors.customGeneralPayment",
  [ERROR_CODES.CREDIT_CARD_AVS_FAIL]: "errors.avsFail",
  [ERROR_CODES.CREDIT_CARD_INVALID_AMOUNT]: "errors.invalidAmount",
  [ERROR_CODES.CREDIT_CARD_INSUFFICIENT_FUNDS]: "errors.insufficientFunds",
  [ERROR_CODES.CREDIT_CARD_INVALID_CVV_ERROR]: "errors.creditCardInvalidCvv",
  [ERROR_CODES.CREDIT_CARD_INVALID_BILLING_ADDRESS_ERROR]: "errors.creditCardInvalidBillingAddress",
  [ERROR_CODES.CREDIT_CARD_INVALID_BILLING_ZIP_ERROR]: "errors.creditCardInvalidBillingZip",
  [ERROR_CODES.CREDIT_CARD_INVALID_ACCOUNT_NUMBER_ERROR]: "errors.creditCardInvalidAccountNumber",
  [ERROR_CODES.CUSTOM_AVS_FAILED_LOW_ERROR]: "errors.customAVSFailedLow",
  [ERROR_CODES.CUSTOM_AVS_FAILED_MED_ERROR]: "errors.customAVSFailedMed",
  [ERROR_CODES.CUSTOM_AVS_FAILED_HIGH_ERROR]: "errors.customAVSFailedHigh",
  [ERROR_CODES.CUSTOM_THREAT_METRIX_ERROR]: "errors.customThreatMetrix",
  [ERROR_CODES.CUSTOM_GENERAL_PAYMENT_ERROR]: "errors.customGeneralPayment",
  [ERROR_CODES.CUSTOM_FREQUENT_PAYMENT_ERROR]: "errors.customFrequentError",
  [ERROR_CODES.DCASH_RETURNS]: "errors.tooManyDCashReturns",
  [ERROR_CODES.EXPERIAN_LINK_REQUEST_FAIL]: "errors.experialLinkRequestFail",
  [ERROR_CODES.EXPERIAN_LINK_NO_NAME_MATCH]: "errors.experianLinkNoNameMatch",
};

export const getErrorMessageId = (error: ApiError) => {
  try {
    const { code }: any = error;
    if (!code) {
      return;
    }
    return errorMessageIds[code];
  } catch (e) {
    return;
  }
};
